import { css } from "@emotion/react"

const ExerciseStyle =  css`

    padding-left: 21px;
    display: flex;
    flex-direction: column;
    position: relative;

    &.veryEasy{
        &:before{
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background: green;
        }
    }
    &.easy{
        &:before{
            width: 14px;
            height: 14px;
            background: #0099D0;
        }
    }
    &.intermediate{
        &:before{
            width: 14px;
            height: 5px;
            background: red;
            top: 10px;
        }
    }
    &.difficult{
        &:before{
            width: 12px;
            height: 12px;
            background: black;
            transform: rotate(45deg);
            top: 3px;
            left: -1px;
        }
    }


    &:before{
        content: "";
        position: absolute;
        left: -2px;
        top: 4px;
    }

    .solution{
        font-size: x-small;
        color: grey;
        display: block;
    }

`


const Exercise = ({level,name,url,solutionUrl}) => {
    return <div className={level} css={ExerciseStyle}>
        <a href={url}>{name}</a>
        {solutionUrl && <a className="solution" href={solutionUrl}>Lösningsförslag</a>}
    </div>
}


export default Exercise